var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"triangle-container"},[_c('div',{staticClass:"line-horizontal",style:({
      width: _vm.pointX + 'px',
      top: _vm.pointY + 'px'
    })}),_c('div',{staticClass:"line-vertical",style:({
      height: _vm.height - _vm.pointY + 'px',
      left: _vm.pointX + 'px',
      top: _vm.pointY + 'px'
    })}),_c('div',{staticClass:"point",style:({
      left: _vm.pointX + 'px',
      top: _vm.pointY + 'px'
    })})])
}
var staticRenderFns = []

export { render, staticRenderFns }